import { useEffect } from 'react'
import { parse } from 'qs'
import cookie from 'cookie'
import { getAffiliateData } from 'api/request'
import { createCookie } from 'utils/cookie'

const buildRequestParams = () => {
  const cookies = cookie.parse(document.cookie)
  const getParams = parse(window.location.search.slice(1))
  const {
    ptnr,
    aff_url_param: affURLParams,
    affiliate: afflt,
    sessionptnr: sptnr,
    first_ptnr: fptnr,
  } = getParams

  const requestParams = {
    ptnr: ptnr || '',
    landing_page: window.location.href,
    alxm: cookies._alxm || '',
    aff_url_param: affURLParams || cookies.aff_url_param || '',
    affiliate: afflt || cookies.affiliate || '',
    sessionptnr: sptnr || cookies.sessionptnr || '',
    first_ptnr: fptnr || cookies.first_ptnr || '',
    referer: document.referrer,
  }
  return requestParams
}

function AffiliateData(props) {
  /* eslint-disable camelcase */
  useEffect(() => {
    getAffiliateData(buildRequestParams())
      .then(responseData => {
        if (responseData.data) {
          const {
            affiliate,
            aff_url_param,
            sessionptnr,
            first_ptnr,
          } = responseData.data

          affiliate &&
            createCookie('affiliate', affiliate.value, affiliate.expire)
          aff_url_param &&
            createCookie(
              'aff_url_param',
              aff_url_param.value,
              aff_url_param.expire
            )
          sessionptnr &&
            createCookie('sessionptnr', sessionptnr.value, sessionptnr.expire)
          first_ptnr &&
            createCookie('first_ptnr', first_ptnr.value, first_ptnr.expire)
        }
      })
      .catch(err => console.log('Err_AffiliateData', err))
  }, [])
  /* eslint-enable camelcase */

  return null
}

export default AffiliateData
